import React, { useState, useEffect } from "react";
import axios from "./axios";
import { IoAlertCircleOutline, IoCheckmarkCircleOutline, IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!token) {
      setError("Token de recuperación faltante o inválido");
    }
  }, [token]);

  const validate = () => {
    setError("");
    setSuccess("");
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return false;
    }
    if (password !== repeatPassword) {
      setError("Las contraseñas no coinciden");
      return false;
    }
    if (!token) {
      setError("Token inválido");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsSubmitting(true);
    try {
      await axios.post(`${apiUrl}/users/password/reset`, JSON.stringify({ token, password }), {
        headers: { "Content-Type": "application/json" },
      });
      setSuccess("Tu contraseña fue restablecida correctamente");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      const msg = err?.response?.data?.error || "Error de conexión";
      setError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <label>
        Nueva contraseña:
        <div className="password-input-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
            aria-label="Toggle password visibility"
          >
            {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
          </button>
        </div>
      </label>
      <label>
        Confirmar contraseña:
        <div className="password-input-wrapper">
          <input
            type={showRepeatPassword ? "text" : "password"}
            name="repeatPassword"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowRepeatPassword(!showRepeatPassword)}
            aria-label="Toggle password visibility"
          >
            {showRepeatPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
          </button>
        </div>
      </label>
      {error && (
        <p className="error-message">
          <IoAlertCircleOutline /> {error}
        </p>
      )}
      {success && (
        <p className="success-message">
          <IoCheckmarkCircleOutline /> {success}
        </p>
      )}
      <button className="button button-info" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Enviando…" : "Restablecer contraseña"}
      </button>
    </form>
  );
};

export default ResetPassword;
